module.exports = __webpack_public_path__ + "img/powered-by.png";